import {
  SET_CURRENT_USER,
} from "actions/types";

const initialState = {
  isAuthenticated: false,
  user: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER:
      if (typeof action.payload.role === "string") {
          action.payload.role = [action.payload.role];
      }
      return {
        ...state,
        isAuthenticated: !!(action.payload && Object.keys(action.payload).length),
        user: action.payload
      };
    default:
      return state;
  }
}
